import {
  API_DOCUMENTOS_CONTABEIS,
  API_LANCAMENTOS_ESTOQUE,
  API_WEBHOOKS_ERP,
} from '../api/apiConfig';
import {
  DocumentoContabil,
  LancamentoEstoqueFinanceiro,
  WebhookERP,
} from '../types/integracaoFinanceira';
import { createCrudService } from './crudFactory';

export const lancamentosEstoqueService =
  createCrudService<LancamentoEstoqueFinanceiro>(API_LANCAMENTOS_ESTOQUE);
export const documentosContabeisService =
  createCrudService<DocumentoContabil>(API_DOCUMENTOS_CONTABEIS);
export const webhooksErpService = createCrudService<WebhookERP>(API_WEBHOOKS_ERP);
